<template>
    <ModalComponent
        :name="name"
        title="Descargar plano de butacas en pdf"
        v-on:close="() => close(false)"
    >
        <div class="card-body">
            <div class="row" v-if="!mensaje">
                <div class="col-12">
                    <h4>Haga clic aquí para descargar el plano de butacas en pdf para esta sesión</h4>
                </div>
                <div class="col-12  ">
                    <Button @click="getPdf()">DESCARGAR</Button>
                </div>
            </div>
            <div v-else>
                <h4>{{ mensaje }}</h4>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['evento', 'sesion_id', 'name'],
        data() {
            return {
                loading: false,
                mensaje: null
            }
        },
        methods: {
            close() {
                this.$emit('close', this.name);
                this.mensaje = null;
            },
            getPdf : function() {
                this.loading = true;
                const data = {
                    evento_id: this.evento.id,
                    sesion_id: this.sesion_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.plano-pdf'), data).then(res => {
                    this.mensaje = "Se esta generando el pdf, recibirá una notificación cuando esté listo.";
                });
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
